import type { BuildingStorageConfig, GameConfig } from './gameConfig';

export function getBuildingInputConfig(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): BuildingStorageConfig | undefined {
    return config.buildings[building].input?.[resource];
}

export function getBuildingOutputConfig(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): BuildingStorageConfig | undefined {
    return config.buildings[building].output?.[resource];
}

export function getBuildingInputMax(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): number {
    return Math.max(0, getBuildingInputConfig(config, building, resource)?.max ?? 0);
}

export function getBuildingOutputMax(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): number {
    return Math.max(0, getBuildingOutputConfig(config, building, resource)?.max ?? 0);
}

export function getBuildingInputBatch(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): number | undefined {
    return getBuildingInputConfig(config, building, resource)?.batch;
}

export function getBuildingOutputBatch(
    config: GameConfig,
    building: keyof GameConfig['buildings'],
    resource: string,
): number | undefined {
    return getBuildingOutputConfig(config, building, resource)?.batch;
}

export function resolveStorageCap(userCap: number, configCap: number): number {
    if (userCap > 0 && configCap > 0) return Math.min(userCap, configCap);
    if (userCap > 0) return userCap;
    if (configCap > 0) return configCap;
    return 0;
}
